import type { UsersT } from '@prismo-io/schemas';
import { GetIntegrationsConfigAction } from '../api/get-integrations-config.action';
import { TsidCard } from '../card';

type Props = {
  user: Pick<UsersT, 'id' | 'url'>;
  baseOrder?: number;
};

export const TsidCardList = async (props: Props) => {
  const { user, baseOrder = 1000 } = props;

  const res = await GetIntegrationsConfigAction({
    userId: user.id,
  });

  if (!res?.data) {
    return null;
  }

  const { data: toolIds } = res;

  return toolIds.map((toolId, idx) => (
    <TsidCard
      key={toolId}
      toolId={toolId}
      user={user}
      order={baseOrder + idx}
    />
  ));
};
